import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user-chengzhang",
  "use": "icon-user-chengzhang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-user-chengzhang\"><path d=\"M925.76 960H161.6A97.728 97.728 0 0 1 64 862.4V162.304a34.304 34.304 0 1 1 68.544 0v700.096a29.12 29.12 0 0 0 29.056 28.992h764.096A34.368 34.368 0 0 1 925.76 960z m-70.784-422.4c-20.16 0-36.48-14.72-36.48-32.832V367.488l-212.224 249.6-218.688-133.504-128.832 174.208c-14.208 12.8-37.312 12.8-51.52 0a30.72 30.72 0 0 1 0-46.528L387.648 390.4l218.688 133.568 139.456-183.872h-109.44c-20.16 0-36.48-14.72-36.48-32.96 0-18.112 16.32-32.832 36.48-32.832h191.104a64 64 0 0 1 64 64v166.4c0 18.176-16.256 32.896-36.48 32.896z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user-chengzhang.svg
// module id = oxN7
// module chunks = 81